import { Component } from '@angular/core';
import { AppstateService } from 'src/app/services/appstate.service';

@Component({
  selector: 'app-assistent-bar',
  templateUrl: './assistent-bar.component.html',
  styleUrl: './assistent-bar.component.scss'
})
export class AssistentBarComponent {

  constructor(public appStateService: AppstateService){

  }
  
}
